import {
  MY_AUCTIONS_FETCH_AUCTIONS,
  MY_AUCTIONS_CREATE_NEW_AUCTION,
  AUCTIONS_HIGHEST_BID_CHANGED
} from 'constants/action-types';
import { DEFAULT_MYAUCTION_LIST_LENGTH } from 'constants/auctions';

export const sortBy = [
  {
    sortType: 'StartDate',
    sortOrderDesc: true
  }
];

export const pagination = {
  recordsReturned: null,
  totalRecordsFound: null,
  currentPage: 1,
  recordsPerPage: DEFAULT_MYAUCTION_LIST_LENGTH
};

const initialState = {
  auctions: [],
  isAuctionsLoading: false,
  filter: {
    sortBy
  },
  pagination
};

export const myAuctions = (state = initialState, action) => {
  switch (action.type) {
    case MY_AUCTIONS_FETCH_AUCTIONS.pending:
      return {
        ...state,
        auctions: initialState.auctions,
        pagination: initialState.pagination,
        filter: initialState.filter,
        isAuctionsLoading: true
      };
    case MY_AUCTIONS_FETCH_AUCTIONS.success:
      return {
        ...state,
        auctions: action.payload.auctions,
        pagination: action.payload.pagination,
        filter: {
          ...initialState.filter,
          ...action.payload.filter
        },
        isAuctionsLoading: false
      };
    case MY_AUCTIONS_CREATE_NEW_AUCTION.success:
      return {
        ...initialState,
        auctions: [action.payload, ...state.auctions]
      };
    case AUCTIONS_HIGHEST_BID_CHANGED: {
      const newAuctions = state.auctions.map(lot => {
        if (lot.auctionId === action.payload.data.AuctionId) {
          return {
            ...lot
            // endDate: action.payload.data.EndDateTime && action.payload.data.EndDateTime
          };
        }
        return lot;
      });
      return {
        ...state,
        auctions: newAuctions
      };
    }
    default:
      return state;
  }
};
